import { filter, firstValueFrom, map, tap, timeout } from 'rxjs';
import { selectionToggle } from '@ardoq/component-selection';
import { logError } from '@ardoq/logging';
import {
  action$,
  dispatchAction,
  extractPayload,
  ofType,
  withNamespace,
} from '@ardoq/rxbeach';
import { GetAdditionalRoutineArgs } from '../../types';
import {
  componentSelectedInHierarchy,
  expandNodeInTree,
} from '../../actions/navigatorActions';

export const getHandleComponentSelectedRoutine = ({
  navigator$,
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  action$.pipe(
    withNamespace(navigatorConfiguration.actionNamespace),
    ofType(componentSelectedInHierarchy),
    extractPayload(),
    tap(async componentId => {
      try {
        // Wait for the node to be available in the tree.
        await firstValueFrom(
          navigator$.pipe(
            map(({ tree }) => tree.getNode(componentId)),
            filter(node => Boolean(node)),
            timeout(3000)
          )
        );
        dispatchAction(
          expandNodeInTree({ nodeId: componentId }),
          navigatorConfiguration.actionNamespace
        );
        dispatchAction(
          selectionToggle({ nodeId: componentId }),
          navigatorConfiguration.actionNamespace
        );
      } catch (e) {
        logError(Error('Selected component not loaded in tree'));
      }
    })
  );
